<div class="taschenrechner-editor">

  <section class="material-section">
    @if (materialTabName !== undefined) {
      <mat-form-field class="material-tab-name-field">
        <mat-label>{{ 'taschenrechner.materialTabLabel' | transloco }}</mat-label>
        <input matInput [(ngModel)]="materialTabName" placeholder="Material" />
      </mat-form-field>
    }
    <div class="editor-wrapper">
      <pixl-editor
        #pixlEditor
        [htmlString]="part().text"
        [editorHeight]="'300px'"
        [bearerToken]="authToken() ?? ''"
        [assetUrl]="assetsUrl()"
        [mediaUrl]="mediaUrl()"
        (callbackFct)="onTextChange($event)"
        [fixedMenu]="true"
        [primaryColor]="playerSettings()?.theme?.primaryColor ?? null"
        [secondaryColor]="playerSettings()?.theme?.secondaryColor ?? null"
        [tertiaryColor]="playerSettings()?.theme?.tertiaryColor ?? null"
        [placeholderColor]="playerSettings()?.theme?.placeholderColor ?? null"
        [hoverColor]="playerSettings()?.theme?.hoverColor ?? null"
        [drawColor]="playerSettings()?.theme?.drawColor ?? null"
        [drawHighlightColor]="playerSettings()?.theme?.drawHighlightColor ?? null"
        [compareSolutionsBgColor]="playerSettings()?.theme?.compareSolutionsBgColor ?? null"
      ></pixl-editor>
    </div>
  </section>

  <section class="items-section">
    <div class="items-toolbar">
      <button mat-button type="button" (click)="collapseAll()">
        <mat-icon>unfold_less</mat-icon>
        {{ 'taschenrechner.collapseAll' | transloco }}
      </button>
      <button mat-button type="button" (click)="expandAll()">
        <mat-icon>unfold_more</mat-icon>
        {{ 'taschenrechner.expandAll' | transloco }}
      </button>
      <span class="syntax-hint">{{ 'taschenrechner.syntaxHint' | transloco }}</span>
    </div>

    <div cdkDropList (cdkDropListDropped)="onDrop($event)" class="items-drop-list">
      @for (item of part().items; track item.id; let i = $index) {
        <div class="item-row" cdkDrag>
          <div class="item-header">
            <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
            <input
              class="item-text-input"
              [ngModel]="item.text"
              (ngModelChange)="onItemTextChange(item, $event)"
              [placeholder]="'taschenrechner.itemTextPlaceholder' | transloco"
            />

            @if (isMathSubject()) {
              <mat-checkbox
                [checked]="isMathEquality(item.id)"
                (change)="setMathEquality(item.id, $event.checked)"
                [matTooltip]="'taschenrechner.mathEqualityTooltip' | transloco"
              >
                {{ 'taschenrechner.mathEquality' | transloco }}
              </mat-checkbox>
            }

            <button
              mat-button
              type="button"
              class="auto-number-btn"
              [disabled]="!canAutoCreateNumberList(item.text)"
              (click)="applyAutoNumberList(item)"
              [matTooltip]="'taschenrechner.autoNumberListTooltip' | transloco"
            >
              <mat-icon>functions</mat-icon>
              {{ 'taschenrechner.autoNumberList' | transloco }}
            </button>

            <button mat-icon-button type="button" (click)="toggleItem(item.id)">
              <mat-icon>{{ expandedItems.has(item.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="removeItem(i)" [matTooltip]="'taschenrechner.deleteItem' | transloco">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          @if (expandedItems.has(item.id)) {
            <div class="item-detail">
              <div class="detail-split">
                <!-- Left column: Correct answer configuration -->
                <div class="detail-left">
                  <mat-checkbox
                    [checked]="!isIgnoredCondition(item.id)"
                    (change)="setIgnoredCondition(item.id, !$event.checked)"
                  >
                    {{ 'taschenrechner.markAsCorrectAnswer' | transloco }}
                  </mat-checkbox>

                  <mat-form-field class="full-width">
                    <mat-label>{{ 'taschenrechner.errorMessage' | transloco }}</mat-label>
                    <textarea
                      matInput
                      [ngModel]="getItemMessage(item.id)"
                      (ngModelChange)="setItemMessage(item.id, $event)"
                      rows="2"
                    ></textarea>
                  </mat-form-field>
                </div>

                <!-- Right column: Conditional errors (only if !isExam()) -->
                @if (!isExam()) {
                  <div class="detail-right">
                    <div class="conditional-errors-header">
                      <h4 class="conditional-errors-title">{{ 'taschenrechner.conditionalErrors' | transloco }}</h4>
                      <button
                        mat-stroked-button
                        type="button"
                        (click)="addConditionalError(item.id)"
                      >
                        <mat-icon>add</mat-icon>
                        {{ 'taschenrechner.addConditionalError' | transloco }}
                      </button>
                    </div>

                    @for (condError of getItemConditionalErrors(item.id); track $index) {
                      <div class="conditional-error-card">
                        <div class="conditional-error-row">
                          <mat-form-field class="cond-right-field">
                            <mat-label>{{ 'taschenrechner.errorFormula' | transloco }}</mat-label>
                            <input
                              matInput
                              [ngModel]="condError.condition.right"
                              (ngModelChange)="onConditionalErrorRightChange(condError, $event)"
                            />
                          </mat-form-field>

                          <button
                            mat-icon-button
                            type="button"
                            (click)="removeConditionalError(condError)"
                            [matTooltip]="'taschenrechner.deleteConditionalError' | transloco"
                          >
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                        <mat-form-field class="full-width">
                          <mat-label>{{ 'taschenrechner.feedbackText' | transloco }}</mat-label>
                          <textarea
                            matInput
                            [ngModel]="condError.message"
                            (ngModelChange)="onConditionalErrorMessageChange(condError, $event)"
                            rows="1"
                          ></textarea>
                        </mat-form-field>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </section>

</div>
